function avatar(author) {
  if (author.avatarUrl) {
    return m('span.dc-avatar', {
      'aria-hidden': 'true'
    }, m('img', {
      src: author.avatarUrl,
      alt: ''
    }));
  }
  return m('span.dc-avatar', {
    'aria-hidden': 'true'
  }, author.username.slice(0, 1).toLocaleUpperCase('ru-RU'));
}
function discussionRow(discussion) {
  return m('article.dc-feed-item', {
    key: discussion.id
  }, [avatar(discussion.author), m('div.dc-feed-item__main', [m('div.dc-feed-item__top', m('a.dc-feed-item__title', {
    href: discussion.url
  }, discussion.title)), m('div.dc-feed-item__meta', [m('span.dc-feed-item__author', discussion.author.username), ...(discussion.tags || []).map(tag => m('a.dc-tag', {
    href: `/t/${tag.slug}`
  }, `#${tag.name}`))])]), m('div.dc-feed-item__stats', [m('span.dc-stat-i', {
    title: 'Ответы'
  }, `💬 ${discussion.comments}`), m('span.dc-stat-i', {
    title: 'Просмотры'
  }, `◉ ${discussion.views}`)])]);
}
function selectDiscussions(portal, activeTab, activeSpace, spaceFeed) {
  let discussions = activeSpace ? spaceFeed?.items || [] : activeTab === 'popular' ? portal.popular : portal.latest;

  // Вкладка без ответа использует реальные счётчики, остальные не подделывают подписки гостю.
  if (activeTab === 'unanswered') discussions = discussions.filter(discussion => discussion.comments === 0);
  if (activeTab === 'popular' && activeSpace) {
    discussions = [...discussions].sort((left, right) => right.comments + right.views - (left.comments + left.views));
  }
  return discussions;
}
export default function Feed(_ref) {
  let {
    portal,
    spaces,
    activeTab,
    activeSpace,
    spaceFeed,
    spaceLoading,
    spaceError,
    onTabChange,
    onSpaceChange,
    onSpaceClear
  } = _ref;
  const discussions = selectDiscussions(portal, activeTab, activeSpace, spaceFeed);
  const selectedSpace = spaces.find(space => space.slug === activeSpace);
  const tabs = [['foryou', 'Для вас'], ['new', 'Новое'], ['popular', 'Популярное'], ['unanswered', 'Без ответа'], ['subs', 'Подписки']];
  return m('div.dc-feedcol', [m('div.dc-spaces-chips', spaces.map(space => m('button.dc-schip', {
    className: activeSpace === space.slug ? 'is-active' : '',
    key: space.url,
    onclick: () => onSpaceChange(activeSpace === space.slug ? null : space.slug)
  }, [m('span.dc-schip__icon', {
    style: `--sp-c:${space.color}`
  }, '{ }'), space.name]))), m('div.dc-composer.dc-card', [m('div.dc-composer__row', [m('span.dc-avatar', '+'), m('a.dc-composer__field', {
    href: '/all'
  }, 'Что хочешь обсудить?')]), m('div.dc-composer__actions', [m('a.dc-composer__btn', {
    href: '/all'
  }, 'Задать вопрос'), m('a.dc-composer__btn', {
    href: '/articles'
  }, 'Написать статью'), m('a.dc-composer__btn', {
    href: '/guides'
  }, 'Создать гайд')])]), m('section.dc-card.dc-feed', {
    'aria-labelledby': 'dc-feed-title'
  }, [m('div.dc-feed__top', [m('h2.dc-feed__title#dc-feed-title', 'Лента'), m('a.dc-btn.dc-btn--ghost.dc-btn--sm', {
    href: '/all'
  }, 'Все фильтры')]), m('div.dc-tabs', {
    role: 'tablist'
  }, tabs.map(_ref2 => {
    let [key, label] = _ref2;
    return m('button.dc-tab', {
      className: key === activeTab ? 'is-on' : '',
      role: 'tab',
      'aria-selected': key === activeTab,
      onclick: () => onTabChange(key)
    }, label);
  })), activeSpace ? m('div.dc-feed__filterbar', m('span.dc-feed__filterchip', [`Пространство: ${spaceFeed?.space?.name || selectedSpace?.name || activeSpace}`, m('button', {
    onclick: onSpaceClear,
    'aria-label': 'Сбросить фильтр'
  }, '×')])) : null, m('div.dc-feed__list', spaceLoading ? m('div.dc-empty', [m('h4', 'Загружаем все материалы…')]) : spaceError ? m('div.dc-empty', [m('h4', 'Не удалось загрузить пространство'), m('p', 'Откройте его ещё раз или перейдите в полный список.')]) : discussions.length ? discussions.map(discussionRow) : m('div.dc-empty', [m('h4', 'Здесь пока тихо'), m('p', 'По выбранному фильтру обсуждений нет. Начните полезную тему первым.')])), m('div.dc-feed__more', m('a.dc-btn.dc-btn--soft', {
    href: selectedSpace?.url || '/all'
  }, activeSpace && spaceFeed ? `Все материалы: ${spaceFeed.total}` : 'Показать ещё'))])]);
}
flarum.reg.add('devconnect-portal', 'forum/components/Feed', Feed);